module.exports = __webpack_public_path__ + "static/media/visa-link.068aa9c5.svg";